import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useItemsStore = create(persist((set) => (
    {
        items: [],
        setItems: (items) => set({ items }),
        addItem: (item) => set((state) => ({ items: [...state.items, item] })),
        updateItem: (item) => set((state) => ({
            items: state.items.map((i) => (i._id === item._id ? item : i)),
        })),
        deleteItem: (itemId) => set((state) => ({
            items: state.items.filter((i) => i._id !== itemId),
        })),
    }
), {
    name: 'items-store',
}));

export default useItemsStore;